import dataLayer from '@/v2/utils/dataLayer';

export const flightModalViewedDataLayerEvent = ({
  flightDirection,
}: {
  flightDirection: 'Departing' | 'Returning';
}) =>
  dataLayer.pageViewEventGA3({
    event: 'flights_page_view',
    title: `${flightDirection} Flight`,
    type: `${flightDirection} Flight`,
  });

export const flightConfirmedDataLayerEvent = ({
  flightIndex,
  flightDirection,
}: {
  flightIndex: number;
  flightDirection: 'Departing' | 'Returning';
}) =>
  dataLayer.userInteractionsEvent({
    category: 'CTA Click',
    action: `${flightDirection} flight confirmed ${flightIndex}`,
    label: 'Flights page',
  });
